import { GreatMemberViewContainer } from 'Views/great-members/GreatMembersView.container';
export default GreatMemberViewContainer;
